export default __webpack_public_path__ + "static/media/masjid img3.46be2e02.jpg";